<div class="container">
  <app-template [title]="'OPD Billing'" *ngIf="!patient && !billItem">
    <div class="no">
      <img
        style="width: 150px; height: 150px; margin-left: 20px"
        src="assets/img/error2.png"
        alt=""
      />
      <a
        routerLink="/register"
        class="waves-effect pull-right"
        style="margin-left: 20px"
      >
        <button
          type="button"
          class="button"
          mat-raised-button
          color="primary"
          style="width: 120px; margin-bottom: 30px"
        >
          Select Patient
        </button>
      </a>
      No patient selected please click on button above to select a patient
    </div>
  </app-template>
  <app-template [title]="'Edit OPD Billing'" *ngIf="billItem" [bill]="'true'">
    <div class="all">
      <div class="both">
        <!-- {{ billItem.id }} -->
        <form
          [formGroup]="stateForm"
          (ngSubmit)="onSubmit($event)"
          class="form"
          [ngSwitch]="mode"
        >
          <div *ngSwitchCase="'form'">
            <span class="input">
              <span class="input">
                <mat-form-field>
                  <mat-label>Patient Type</mat-label>
                  <mat-select formControlName="patient_type" matNativeControl>
                    <mat-option
                      *ngFor="let type of patientTypeList"
                      [value]="type.OptionValue"
                    >
                      {{ type.OptionName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </span>

              <span class="input">
                <mat-form-field>
                  <mat-label>Patient Organization</mat-label>
                  <mat-select formControlName="ref_hosp_code" matNativeControl>
                    <mat-option
                      *ngFor="let type of refCodeList"
                      [value]="type.Id"
                    >
                      {{ type.OptionName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </span>

              <span class="input">
                <mat-form-field>
                  <mat-label>Concession Code</mat-label>
                  <mat-select
                    formControlName="concession_code"
                    matNativeControl
                  >
                    <mat-option
                      *ngFor="let type of concessionCodeList"
                      [value]="type.Id"
                    >
                      {{ type.OptionName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </span>

              <span class="input">
                <mat-form-field>
                  <mat-label>Clinical History</mat-label>
                  <textarea
                    formControlName="clinical_history"
                    matInput
                    placeholder=""
                  ></textarea>
                </mat-form-field>
              </span>
            </span>
            <br />
            <span class="input">
              <span class="input" *ngIf="canDiscount.length > 0">
                <mat-form-field>
                  <mat-label>Authorized By</mat-label>
                  <mat-select
                    formControlName="discount_auth_doc_id"
                    matNativeControl
                  >
                    <mat-option
                      *ngFor="let type of users"
                      [value]="type.Employee_id"
                    >
                      {{ type.First_Name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </span>

              <span class="input">
                <mat-form-field>
                  <mat-label>Reason</mat-label>
                  <input
                    formControlName="discount_narration"
                    matInput
                    placeholder=""
                  />
                </mat-form-field>
              </span>

              <span *ngIf="canDiscount.length > 0">
                <span class="input">
                  <mat-form-field>
                    <mat-label>Manual Discount In Naira</mat-label>
                    <input
                      [(ngModel)]="total_discount"
                      type="number"
                      (change)="onChangePer()"
                      name="total_discount"
                      matInput
                      placeholder=""
                      [ngModelOptions]="{ standalone: true }"
                    />
                  </mat-form-field>
                </span>

                <span class="input">
                  <mat-form-field>
                    <mat-label>Manual Discount In %</mat-label>
                    <input
                      [(ngModel)]="discount"
                      type="number"
                      (change)="onChange()"
                      name="discount"
                      [value]="discount | number"
                      matInput
                      placeholder=""
                      [ngModelOptions]="{ standalone: true }"
                    />
                  </mat-form-field>
                </span>
              </span>
            </span>

            <div class="detail" *ngIf="billItem">
              <table style="width: 25%; border: 0px">
                <tr style="border: 0px">
                  <td style="border: 0px"><p>Amount</p></td>
                  <td style="border: 0px; text-align: left">
                    <b>{{ total | currency : "&#8358;" }}</b>
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px"><p>Balance</p></td>
                  <td style="border: 0px; text-align: left">
                    <b>{{ discount_amout | currency : "&#8358;" }} </b>
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px"><p>Ref Doctor</p></td>
                  <td style="border: 0px; text-align: left">
                    <b>{{ doctorRef }} </b>
                  </td>
                </tr>
              </table>
              <table style="width: 25%" *ngIf="canDiscount.length > 0">
                <tr>
                  <td style="border: 0px">Discount</td>
                  <td style="border: 0px">
                    <b> {{ total_discount | currency : "&#8358;" }}</b>
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px">Discount%:</td>
                  <td style="border: 0px; text-align: left">
                    <b>{{ discount?.toFixed() }}%</b>
                  </td>
                </tr>
              </table>
              <table style="width: 35%">
                <tr>
                  <td style="border: 0px">Name :</td>
                  <td style="border: 0px; text-align: left">
                    {{ billItem?.firstName }}
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px">Mobile :</td>
                  <td style="border: 0px; text-align: left">
                    <b>{{ billItem?.patient_phone }}</b>
                  </td>
                </tr>
              </table>
              <table style="width: 10%">
                <tr>
                  <td style="border: 0px" *ngIf="canDiscount.length === 0">
                    <button
                      *ngIf="!billLoad"
                      [disabled]="stateForm.invalid"
                      class="bill"
                      type="submit"
                      mat-raised-button
                      color="primary"
                      (click)="saveDraft()"
                    >
                      Update as draft
                    </button>
                    <button
                      *ngIf="billLoad"
                      [disabled]="stateForm.invalid"
                      type="button"
                      class="bill"
                      mat-raised-button
                      color="primary"
                    >
                      <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                    </button>
                  </td>
                  <td style="border: 0px">
                    <button
                      *ngIf="!billLoad"
                      [disabled]="stateForm.invalid"
                      class="bill"
                      type="submit"
                      mat-raised-button
                      color="primary"
                    >
                      Update Bill
                    </button>
                    <button
                      *ngIf="billLoad"
                      [disabled]="stateForm.invalid"
                      type="button"
                      class="bill"
                      mat-raised-button
                      color="primary"
                    >
                      <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </form>

        <div class="content-mx-width" style="margin-right: 100px">
          <div (click)="refVisibility()">
            <button
              style="margin-top: 10px; margin-right: 100px"
              mat-raised-button
              color="primary"
            >
              Ref Doctor
            </button>
          </div>
          <div class="mobile" *ngIf="refVisible" [@simpleFadeAnimation]="'in'">
            <div class="mobile_nav">
              <div class="service">
                <table style="width: 400px">
                  <tr class="back">
                    <th>
                      <input
                        type="text"
                        class="form-control"
                        id="search-text"
                        aria-describedby="search-text"
                        [(ngModel)]="searchDoc"
                        placeholder="Search items"
                        autofocus
                      />
                    </th>
                    <th>Code</th>
                  </tr>
                  <tr
                    *ngFor="let item of filteredDocs"
                    (click)="addRefDoc(item)"
                    style="cursor: pointer"
                    [ngClass]="{ active: item.selected }"
                  >
                    <td [ngClass]="{ inActive: item.status === 'InActive' }">
                      {{ item.Acount_Name }}
                    </td>
                    <td [ngClass]="{ inActive: item.status === 'InActive' }">
                      {{ item.ref_doctor_code }}
                    </td>
                  </tr>
                </table>
                <div *ngIf="isLoading" class="spinner" style="margin-top: 40px">
                  <mat-spinner></mat-spinner>
                </div>
                <div class="errorMessage">
                  <div *ngIf="Errors" class="error">
                    <p>{{ Errors }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="content-mx-width">
          <div class="divider"></div>
          <div class="toggle" (click)="togle()">
            <button
              style="margin-top: 10px; margin-right: 100px"
              mat-raised-button
              color="primary"
            >
              Item Of Service
            </button>
          </div>
          <div class="mobile" *ngIf="isVisible" [@simpleFadeAnimation]="'in'">
            <div class="mobile_nav">
              <div class="service">
                <table style="width: 400px">
                  <tr class="back">
                    <th>
                      <input
                        type="text"
                        class="form-control"
                        id="search-text"
                        aria-describedby="search-text"
                        [(ngModel)]="searchText"
                        placeholder="Search items"
                        autofocus
                      />
                    </th>
                    <th>Price</th>
                  </tr>
                  <tr
                    *ngFor="let item of filteredItems"
                    (click)="addItem(item)"
                    style="cursor: pointer"
                    [ngClass]="{ active: item.selected }"
                  >
                    <td [ngClass]="{ inActive: item.status === 'InActive' }">
                      {{ item.name }}
                    </td>
                    <td [ngClass]="{ inActive: item.status === 'InActive' }">
                      {{ item.service_price }}
                    </td>
                  </tr>
                </table>
                <div *ngIf="isLoading" class="spinner" style="margin-top: 40px">
                  <mat-spinner></mat-spinner>
                </div>
                <div class="errorMessage">
                  <div *ngIf="Errors" class="error">
                    <p>{{ Errors }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="item">
          <table style="width: 100%">
            <tr class="back">
              <th>Name</th>
              <th>Price</th>
              <th>Dept</th>
              <th>Sub Dept</th>
              <th>Status</th>
              <th>
                <button (click)="clear()" mat-raised-button color="basic">
                  Clear All
                </button>
              </th>
            </tr>
            <tr
              class="td"
              *ngFor="let item of data"
              style="cursor: pointer"
              [ngClass]="{ inActive: item.status === 'InActive' }"
            >
              <td>{{ item.name }}</td>
              <td>{{ item.service_price | currency : "&#8358;" }}</td>
              <td>{{ item.dept_name }}</td>
              <td>{{ item.sub_dept_name }}</td>
              <td>{{ item?.status || "Active" }}</td>
              <td>
                <button
                  (click)="deleteItem(item)"
                  mat-raised-button
                  color="primary"
                >
                  Remove
                </button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </app-template>

  <app-template
    [title]="'OPD Billing'"
    *ngIf="patient && !billItem"
    [bill]="'true'"
  >
    <div class="all">
      <div class="both">
        <form
          [formGroup]="stateForm"
          (ngSubmit)="onSubmit($event)"
          class="form"
          [ngSwitch]="mode"
        >
          <div *ngSwitchCase="'form'">
            <span class="input">
              <span class="input">
                <mat-form-field>
                  <mat-label>Patient Type</mat-label>
                  <mat-select formControlName="patient_type" matNativeControl>
                    <mat-option
                      *ngFor="let type of patientTypeList"
                      [value]="type.OptionValue"
                    >
                      {{ type.OptionName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </span>

              <span class="input">
                <mat-form-field>
                  <mat-label>Patient Organization</mat-label>
                  <mat-select formControlName="ref_hosp_code" matNativeControl>
                    <mat-option
                      *ngFor="let type of refCodeList"
                      [value]="type.Id"
                    >
                      {{ type.OptionName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </span>

              <span class="input">
                <mat-form-field>
                  <mat-label>Concession Code</mat-label>
                  <mat-select
                    formControlName="concession_code"
                    matNativeControl
                  >
                    <mat-option
                      *ngFor="let type of concessionCodeList"
                      [value]="type.Id"
                    >
                      {{ type.OptionName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </span>

              <span class="input">
                <mat-form-field>
                  <mat-label>Clinical History</mat-label>
                  <textarea
                    formControlName="clinical_history"
                    matInput
                    placeholder=""
                  ></textarea>
                </mat-form-field>
              </span>
            </span>
            <br />
            <span class="input">
              <span class="input" *ngIf="canDiscount.length > 0">
                <mat-form-field>
                  <mat-label>Authorized By</mat-label>
                  <mat-select
                    formControlName="discount_auth_doc_id"
                    matNativeControl
                  >
                    <mat-option
                      *ngFor="let type of users"
                      [value]="type.Employee_id"
                    >
                      {{ type.First_Name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </span>

              <span class="input">
                <mat-form-field>
                  <mat-label>Reason</mat-label>
                  <input
                    formControlName="discount_narration"
                    matInput
                    placeholder=""
                  />
                </mat-form-field>
              </span>
              <span *ngIf="canDiscount.length > 0">
                <span class="input">
                  <mat-form-field>
                    <mat-label>Manual Discount In Naira</mat-label>
                    <input
                      [(ngModel)]="total_discount"
                      type="number"
                      (change)="onChangePer()"
                      name="total_discount"
                      matInput
                      placeholder=""
                      [ngModelOptions]="{ standalone: true }"
                    />
                  </mat-form-field>
                </span>

                <span class="input">
                  <mat-form-field>
                    <mat-label>Manual Discount In %</mat-label>
                    <input
                      type="number"
                      [(ngModel)]="discount"
                      (change)="onChange()"
                      name="discount"
                      [value]="discount | number"
                      matInput
                      placeholder=""
                      [ngModelOptions]="{ standalone: true }"
                    />
                  </mat-form-field>
                </span>
              </span>
            </span>
            <div class="detail" *ngIf="patient">
              <table style="width: 25%; border: 0px">
                <tr style="border: 0px">
                  <td style="border: 0px"><p>Amount</p></td>
                  <td style="border: 0px; text-align: left">
                    <b>{{ total | currency : "&#8358;" }}</b>
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px"><p>Balance</p></td>
                  <td style="border: 0px; text-align: left">
                    <b>{{ discount_amout | currency : "&#8358;" }} </b>
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px"><p>Ref Doctor</p></td>
                  <td style="border: 0px; text-align: left">
                    <b>{{ doctorRef }} </b>
                  </td>
                </tr>
              </table>
              <table style="width: 25%" *ngIf="canDiscount.length > 0">
                <tr>
                  <td style="border: 0px">Discount</td>
                  <td style="border: 0px">
                    <b> {{ total_discount | currency : "&#8358;" }}</b>
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px">Discount%:</td>
                  <td style="border: 0px; text-align: left">
                    <b>{{ discount?.toFixed() }}%</b>
                  </td>
                </tr>
              </table>
              <table style="width: 35%">
                <tr>
                  <td style="border: 0px">Name :</td>
                  <td style="border: 0px; text-align: left">
                    {{ patient?.first_name }}
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px">Mobile :</td>
                  <td style="border: 0px; text-align: left">
                    <b>{{ patient?.mobile }}</b>
                  </td>
                </tr>
              </table>
              <table style="width: 10%">
                <tr>
                  <td style="border: 0px" *ngIf="canDiscount.length === 0">
                    <button
                      [disabled]="doctorRef === '' || doctorRef === undefined"
                      class="bill"
                      type="submit"
                      mat-raised-button
                      color="primary"
                      (click)="saveDraft()"
                    >
                      <span *ngIf="!billLoad">Save as Draft</span>
                      <span *ngIf="billLoad">
                        <i class="fa fa-spinner fa-spin" aria-hidden="true"></i
                      ></span>
                    </button>
                  </td>
                  <td style="border: 0px">
                    <button
                      [disabled]="doctorRef === '' || doctorRef === undefined"
                      class="bill"
                      type="submit"
                      mat-raised-button
                      color="primary"
                    >
                      <span *ngIf="!billLoad">Save Bill</span>
                      <span *ngIf="billLoad">
                        <i class="fa fa-spinner fa-spin" aria-hidden="true"></i
                      ></span>
                    </button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </form>
        <div class="content-mx-width" style="margin-right: 100px">
          <div (click)="refVisibility()">
            <button
              style="margin-top: 10px; margin-right: 100px"
              mat-raised-button
              color="primary"
            >
              Ref Doctor
            </button>
          </div>
          <div class="mobile" *ngIf="refVisible" [@simpleFadeAnimation]="'in'">
            <div class="mobile_nav">
              <div class="service">
                <table style="width: 400px">
                  <tr class="back">
                    <th>
                      <input
                        type="text"
                        class="form-control"
                        id="search-text"
                        aria-describedby="search-text"
                        [(ngModel)]="searchDoc"
                        placeholder="Search items"
                        autofocus
                      />
                    </th>
                    <th>Code</th>
                  </tr>
                  <tr
                    *ngFor="let item of filteredDocs"
                    (click)="addRefDoc(item)"
                    style="cursor: pointer"
                    [ngClass]="{ active: item.selected }"
                  >
                    <td [ngClass]="{ inActive: item.status === 'InActive' }">
                      {{ item.Acount_Name }}
                    </td>
                    <td [ngClass]="{ inActive: item.status === 'InActive' }">
                      {{ item.ref_doctor_code }}
                    </td>
                  </tr>
                </table>
                <div *ngIf="isLoading" class="spinner" style="margin-top: 40px">
                  <mat-spinner></mat-spinner>
                </div>
                <div class="errorMessage">
                  <div *ngIf="Errors" class="error">
                    <p>{{ Errors }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="content-mx-width">
          <div class="divider"></div>
          <div class="toggle" (click)="togle()">
            <button
              style="margin-top: 10px; margin-right: 100px"
              mat-raised-button
              color="primary"
            >
              Item Of Service
            </button>
          </div>
          <div class="mobile" *ngIf="isVisible" [@simpleFadeAnimation]="'in'">
            <div class="mobile_nav">
              <div class="service">
                <table style="width: 400px">
                  <tr class="back">
                    <th>
                      <input
                        type="text"
                        class="form-control"
                        id="search-text"
                        aria-describedby="search-text"
                        [(ngModel)]="searchText"
                        placeholder="Search items"
                        autofocus
                      />
                    </th>
                    <th>Price</th>
                  </tr>
                  <tr
                    *ngFor="let item of filteredItems"
                    (click)="addItem(item)"
                    style="cursor: pointer"
                    [ngClass]="{ active: item.selected }"
                  >
                    <td [ngClass]="{ inActive: item.status === 'InActive' }">
                      {{ item.name }}
                    </td>
                    <td [ngClass]="{ inActive: item.status === 'InActive' }">
                      {{ item.service_price }}
                    </td>
                  </tr>
                </table>
                <div *ngIf="isLoading" class="spinner" style="margin-top: 40px">
                  <mat-spinner></mat-spinner>
                </div>
                <div class="errorMessage">
                  <div *ngIf="Errors" class="error">
                    <p>{{ Errors }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="item">
          <table style="width: 100%">
            <tr class="back">
              <th>Name</th>
              <th>Price</th>
              <th>Dept</th>
              <th>Sub Dept</th>
              <th>Status</th>
              <th>
                <button (click)="clear()" mat-raised-button color="basic">
                  Clear All
                </button>
              </th>
            </tr>
            <tr
              class="td"
              *ngFor="let item of data"
              style="cursor: pointer"
              [ngClass]="{ inActive: item.status === 'InActive' }"
            >
              <td>{{ item.name }}</td>
              <td>{{ item.service_price }}</td>
              <td>{{ item.dept_name }}</td>
              <td>{{ item.sub_dept_name }}</td>
              <td>{{ item.status }}</td>
              <td>
                <button
                  (click)="deleteItem(item)"
                  mat-raised-button
                  color="primary"
                >
                  Remove
                </button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </app-template>
</div>
<div class="doc" *ngIf="docVisible" [@simpleFadeAnimation]="'in'">
  <table style="width: 100%">
    <tr class="back">
      <th>Refered By</th>
      <th>
        <input
          type="text"
          class="form-control"
          id="search-text"
          aria-describedby="search-text"
          [(ngModel)]="searchDoc"
          placeholder="Search items"
          autofocus
        />
      </th>
    </tr>
    <tr
      *ngFor="let item of filteredDocs"
      style="cursor: pointer"
      (click)="setRef(item)"
    >
      <td>{{ item.Acount_Name }}</td>
      <td>{{ item.mobile }}</td>
    </tr>
  </table>
  <div *ngIf="docIsLoading" class="spinner" style="margin-top: 40px">
    <mat-spinner></mat-spinner>
  </div>
</div>
<div class="doc" *ngIf="authVisible" [@simpleFadeAnimation]="'in'">
  <table style="width: 100%">
    <tr class="back">
      <th>Authorized By</th>
      <th>
        <input
          type="text"
          class="form-control"
          id="search-text"
          aria-describedby="search-text"
          [(ngModel)]="searchDoc"
          placeholder="Search items"
          autofocus
        />
      </th>
    </tr>
    <tr
      *ngFor="let item of referred_doc"
      style="cursor: pointer"
      (click)="setAuth(item)"
    >
      <td>{{ item.Acount_Name }}</td>
      <td>{{ item.mobile }}</td>
    </tr>
  </table>
  <div *ngIf="docIsLoading" class="spinner" style="margin-top: 40px">
    <mat-spinner></mat-spinner>
  </div>
</div>
